export default function({ state, commit, dispatch }, filter) {
    commit('startTestingFilter')

    return dispatch('post', {
        url: '/provider/' + state.id + '/filter',
        data: Object.assign({ test: true }, filter)
    }, {
        root: true
    })
    .then((response) => {
        commit('finishTestingFilter')
		return response
    })
    .catch((error) => {
        commit('finishTestingFilter')
		throw error
    })
}
